export const AiParseRcState = {
  DISABLED: "DISABLED",
  MANUAL: "MANUAL",
} as const;

export type AiParseRcState =
  (typeof AiParseRcState)[keyof typeof AiParseRcState];
